import PropTypes from 'prop-types';
import React from 'react';
import Button from '../Button';
import Spinner from '../Spinner';

const LoadMore = ({
  children,
  showSpinner = false,
  onClick
}) => (
  <div className="load-more">
    <Button className="load-more__button" onClick={onClick} disabled={showSpinner}>
      {showSpinner
        ? (<Spinner className="spinner--small spinner--on-dark" />)
        : children
      }
    </Button>
  </div>
);

LoadMore.propTypes = {
  children: PropTypes.node,
  showSpinner: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default LoadMore;
